module.exports = __webpack_public_path__ + "static/media/nextDown.4110db63.svg";